import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-hot-toast';

import { Guid } from '../../types';
import adminFinesService from '../../services/api/admin-fines/admin-fines.service';

export const useMoveFinesToPaidFromProfile = () => {
  const queryClient = useQueryClient();
  return useMutation<void, string[], Guid[]>(
    (checkedFines) => adminFinesService.moveFinesToPaidFromProfile(checkedFines),
    {
      onError: () => {
        toast.error('Error Moving Fines To Paid.');
      },
      onSuccess: () => {
        queryClient.invalidateQueries(['paged-profile-fines']);
      },
    },
  );
};
